import React, { useEffect, useState } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import { useDispatch } from "react-redux";
import { subDays, format } from 'date-fns';

import {
  Item,
  ItemTitle,
  ItemDetails,
  Details,
  StatusCollor,
  Status,
  ImgDetails,
  ItemStatusResponsive,
  ItemDesktop,
  DivisionItems,
  ItemDetailsRight,
  ItemRight,
  ContentTitle,
  ContentStatus,
  DivisionEdit
} from "./styles";

import api from "~/services/api";
import information from "~/assets/images/information.svg";
import { analytics, logEvent }  from "~/services/firebaseConfig";

export default function ItemList({
  order,
  setOrderChoosed,
  activeModal,
}) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [hasEdit, setHasedit] = useState(false);
  const [hasEditHour, setHaseditHour] = useState(false);

  useEffect(() => {
    let todayDate = moment().format("DD/MM/YYYY")
    let todayMouth = moment().format("MM")
    let hourNow = moment().format("HH:mm")
    let continueCount = todayDate < moment(order.cutDate).format("DD/MM/YYYY")
    let continueCountMounth = moment(order.cutDate).format("MM") >= todayMouth
    if(continueCount && continueCountMounth) {
      if(todayDate < moment(order.cutDate).format("DD/MM/YYYY")) {
        if(todayDate === moment(order.cutDate).format("DD/MM/YYYY")) {
          if(hourNow > moment(order.cutDate, "HH:mm:ss").format("HH:mm")) {
            setHaseditHour(false)
          } else {
            setHaseditHour(true)
          }
        } else {
          setHaseditHour(true)
        }
      } else {
        setHaseditHour(false)
      }
    } else {
      setHaseditHour(false)
    }
  }, []);


  const StatusText = ({ status }) => {
    const shouldEdit = (
      status === "AGUARDANDO ANÁLISE DO FINANCEIRO" ||
      status === "EM ANÁLISE PELO FINANCEIRO" ||
      status === "AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO" ||
      status === "AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO"
    );

    const needsPrefix = (
      status === "AGUARDANDO PAGAMENTO" ||
      status === "AGUARDANDO ANÁLISE DO FINANCEIRO" ||
      status === "EM ANÁLISE PELO FINANCEIRO" ||
      status === "AGUARDANDO APROVAÇÃO DA LOGÍSTICA PARA INCLUSÃO NA PROGRAMAÇÃO" ||
      status === "AGUARDANDO APROVAÇÃO DO CONSULTOR COMERCIAL PARA INCLUSÃO NA PROGRAMAÇÃO" ||
      status === "PENDENTE DE PAGAMENTO DE DIVIDAS ANTERIORES" ||
      status === "VALIDAR COMPROVANTE"
    );

    if (shouldEdit) {
      hasEditHour ? setHasedit(true) : setHasedit(false);
    }

    return (
      <span>
        {needsPrefix ? status.toUpperCase() : `PEDIDO ${status.toUpperCase()}`}
      </span>
    );
  };




  function handleClick(id) {
    logEvent(analytics, 'detalhes_de_pedido');
    return history.push("/status-pedido?id=" + id);
  }

  const getOrders = () => {

    if(window.screen.width > 768) {
      activeModal(true);
      const header = {
        'Content-Type': 'application/json',
        access_token: localStorage.getItem('access_token'),
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };

      const currentDate = new Date();
      const startDate = subDays(currentDate, 60);
      const formattedStartDate = format(startDate, 'yyyy-MM-dd');

      const storeId = localStorage.getItem('storeId');
      const url = `/residential/order/v1/orders-ga?store-id=${storeId}&start-date=${formattedStartDate}`;
      api
        .get(url, parameters)
        .then(async res => {
          setOrderChoosed(order);
          let settingOrders = [res.data];
          let orderImutChoosed = null
          settingOrders[0].map((element) => {
            if(order.id === element.id) {
              orderImutChoosed = element
            }
          })
          await dispatch({ type: "SET_ORDER_EDIT", orderChoosed: orderImutChoosed });
          await dispatch({ type: "SET_REQUISITION_EDIT", requisitionEdit: true });
        })
        .catch(err => {});
    } else {
      history.push("/edição-pedido");
      setOrderChoosed(order);
      dispatch({ type: "SET_ORDER_EDIT", orderChoosed: order });
    }
  };

  return (
    <DivisionItems>
      <Item>
        <>
          <ContentTitle>
            <ItemTitle fontSize={"1rem"}>Pedido {order.number}</ItemTitle>
            <ItemTitle weight={"400"} fontSize={".7rem"}>
              {moment(order.deliveryDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
            </ItemTitle>
          </ContentTitle>
          <ItemStatusResponsive>
            <ItemDetails>
              <Status>Status: </Status>
              <ContentStatus>
                {/* <StatusCollor status={order.status}></StatusCollor> */}
                <StatusText status={order.status} />
              </ContentStatus>
            </ItemDetails>
            <ItemDetails
              onClick={() => handleClick(order.id)}
              margin={'.3rem 0 0 0'}
              margin500={'.5rem -.1rem 0 0'}
              style={ItemDetailsRight}
            >
              <Details>
                Detalhes
                <ImgDetails src={information} alt="Ícone de informações" />
              </Details>
            </ItemDetails>
            <div />
            {
              hasEdit ? (
                <DivisionEdit onClick={() => {
                  getOrders();
                }}>
                  <CreateOutlinedIcon />
                  Editar
                </DivisionEdit>
              ) : null
            }
          </ItemStatusResponsive>
        </>
      </Item>
      <ItemDesktop>
        <ContentTitle>
          <ItemTitle fontSize={"1rem"}>Pedido {order.number}</ItemTitle>
          <ItemRight>
            <ItemDetails>
              <Status>Status: </Status>
              <ContentStatus>
                {/* <StatusCollor status={order.status}></StatusCollor> */}
                <StatusText status={order.status} />
              </ContentStatus>
            </ItemDetails>
            <div style={{
              display: "grid",
              gridTemplateColumns: "2fr 1fr"
            }}>
              {
                hasEdit ? (
                  <DivisionEdit onClick={() => {
                    dispatch({ type: "SET_REQUISITION_EDIT", requisitionEdit: false });
                    getOrders();
                  }}>
                    <CreateOutlinedIcon />
                    Editar
                  </DivisionEdit>
                ) : <div />
              }
              <ItemTitle weight={"400"} fontSize={".7rem"} style={{ flexDirection: 'column' }}>
                <p style={{ color: '#707070' }}>Data: </p>
                {moment(order.deliveryDate, "YYYY-MM-DD").format("DD/MM/YYYY")}
              </ItemTitle>
            </div>
          </ItemRight>
          <Details onClick={() => handleClick(order.id)}>
            Detalhes
            <ImgDetails src={information} alt="Ícone de informações" />
          </Details>
        </ContentTitle>
      </ItemDesktop>
    </DivisionItems>
  );
}
